import React from 'react'

import { Container, Type, Value } from './styles'
import { Item, Background, Text, Check } from '../../ListItem'

function LeaderboardItem (props){
  return (
    <Container>
      <Type>
        <Item>
          <Background/>
          <Text>{ props.type }</Text>
        </Item>
      </Type>
      <Value>
        <Item>
          <Background/>
          <Text>{ props.value }</Text>
        </Item>
      </Value>
    </Container>
  )
}

export default LeaderboardItem